import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";

import { IconChevronDown } from "@pentabd/icons";
import { InputSelect, Select, Text } from "@pentabd/ui";

import { OnChangeType, OptionType, RenderType, SelectionType } from "@pentabd/ui/build/atoms/select/types";

interface SelectType {
  name: string;
  options: OptionType[];
  actionHandler: (value: string) => void;

  label?: string;
  placeholder?: string;
  formMethods?: (setValue: any) => void;

  validation?: any;
  required?: boolean;
  status?: "primary" | "secondary" | "danger" | "warning" | "success" | "info";
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  isMulti?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  onChange?: OnChangeType;
  suffix?: JSX.Element | JSX.Element[] | string;
  prefix?: JSX.Element | JSX.Element[] | string;
  stablePrefix?: boolean;
  stableSuffix?: boolean;
  disabled?: boolean;
  renderSelected?: RenderType;
  value?: string | number | string[];
  defaultValue?: string;
  onSelectItem?: (data: SelectionType) => void;
  portal?: boolean;
  minWidth?: boolean;
  emptyMessage?: string;
}

export const SelectControllerOptions = ({
  name,
  options,
  actionHandler,

  label,
  placeholder,
  formMethods,
  defaultValue,

  validation = {},
  disabled,
  required,
  size = "xs",
  portal = true,
  isMulti,
  isClearable,
  isSearchable,
}: SelectType) => {
  const methods = useForm<{ [key: string]: string }>();

  const {
    register,
    control,
    setValue,
    reset,
    formState: { errors },
  } = methods;

  useEffect(() => {
    formMethods && formMethods(methods);
    reset();

    setValue(name, defaultValue || "all");
    return () => {
      reset();
    };
  }, []);

  return (
    <div>
      <Text
        weight="semibold"
        color="title"
        size="sm"
        component="p"
        className="mb-3"
      >
        {label}
        {required && <span className="text-danger">&#42;</span>}
      </Text>
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          return (
            <InputSelect
              {...register(name, { ...validation })}
              options={options}
              defaultValue={field.value as string}
              onSelectItem={(e) => {
                setValue(name, e as string);
                actionHandler(e as string);
              }}
              suffix={<IconChevronDown size="16" />}
              placeholder={placeholder}
              disabled={disabled}
              size={size}
              portal={portal}
              isMulti={isMulti}
              isClearable={isClearable}
              isSearchable={isSearchable}
              error={errors as any}
            />
          );
        }}
      />
    </div>
  );
};
